module.exports = __webpack_public_path__ + "img/logo_rincontravel.99a0ff42.gif";